<template>
  <div class="existing-grip-data-list-container">
    <div class="container-header">
      <div class="flex space-between">
        <h1 class="header-title">
          Existing Enabler(s)
          <b-tooltip
            :active="true"
            :label="enablerInfo"
            position="is-right"
            size="is-medium"
            multilined
          >
            <b-icon
              icon="information-outline"
              size="is-small"
              class="padding"
            />
          </b-tooltip>
          <a class="icon-box" @click="getEnablers()">
            <b-icon icon="refresh" size="is-small" class="padding"></b-icon>
          </a>
        </h1>
        <a class="icon-box" @click="collapseSideNav()">
          <b-icon icon="chevron-double-left" size="is-medium"></b-icon>
        </a>
      </div>
      <div class="padding-vertical-12">
        <b-field class="grip-search-input-box">
          <b-input
            type="search"
            icon="magnify"
            placeholder="Search Enabler(s)"
            v-model="searchTitle"
          >
          </b-input>
        </b-field>
      </div>
    </div>
    <BaseLoading v-if="isLoading" />
    <div v-else-if="enablerList.length > 0" class="list-container">
      <div
        :key="index"
        v-for="(enabler, index) in enablerList"
        draggable="true"
        v-on:dragstart="onDragStart($event, enabler)"
        class="item-box border-bottom-Gray86"
      >
        <div class="draggable-icon">
          <div class="display-icon">
            <img src="@/assets/images/ic-drag-blue.png" class="drag-icon" />
          </div>
        </div>
        <div class="flex cell flex-column overflow-auto">
          <b class="item-title">
            {{ enabler.title }}
          </b>
          <p v-if="enabler.gripDomainCategory" class="category-box">
            {{ getUpperCase(enabler.gripDomainCategory.name) }}
          </p>
          <p class="description">
            {{ enabler.description }}
          </p>
        </div>
      </div>
    </div>
    <div v-else class="null-container">
      <p>No enabler(s) found.</p>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import { Debounce } from '../../../jbi-shared/util/debounce.vue-decorator';
import { ApiState, Pagination } from '../../../store/types/general.types';
import {
  CreateGripEnablerBase,
  GetEnablersPayload,
  GripEnabler,
} from '../../../store/types/grip.types';

@Component({
  components: { BaseLoading },
})
export default class ExistingGripEnablerList extends Vue {
  @Prop() public projectId!: number;
  public isLoading: boolean = true;
  public searchTitle: string = '';
  public perPage: number = 100;
  public page: number = 1;
  public enablerList: GripEnabler[] = [];
  public enablerInfo: string =
    'Enablers to the utilisation of evidence in practice.';

  @Action('projects/getGripEnablers')
  public getGripEnablers!: (payload: {
    projectId: number;
    params: GetEnablersPayload;
  }) => void;

  @State((state) => state.projects.gripEnablers)
  public gripEnablers!: Pagination<GripEnabler>;

  @State((state) => state.projects.apiState.getGripEnablers)
  public getGripEnablersApiState!: ApiState;

  public getUpperCase(value: string): string {
    return value.toUpperCase();
  }

  public createAnalysisEnablerItem(
    enabler: GripEnabler,
  ): CreateGripEnablerBase {
    return {
      title: enabler.title,
      description: enabler.description,
      links: enabler.links,
      attachments: enabler.attachments,
      gripDomainCategoryId: enabler.gripDomainCategory
        ? enabler.gripDomainCategory.id
        : null,
    };
  }

  public onDragStart(event: any, enabler: GripEnabler): void {
    const newItem = this.createAnalysisEnablerItem(enabler);
    const jsonData = JSON.stringify({ ...newItem, itemType: 'enabler' });
    event.dataTransfer.setData('application/json', jsonData);
  }

  public getEnablers(): void {
    this.isLoading = true;
    this.getGripEnablers({
      projectId: this.projectId,
      params: {
        title: this.searchTitle,
        limit: this.perPage,
        page: this.page,
      },
    });
  }

  public collapseSideNav(): void {
    this.$emit('collapseSideNav');
  }

  public mounted(): void {
    this.getEnablers();
  }

  @Watch('searchTitle')
  @Debounce(500)
  public onTitleSearch(): void {
    this.getEnablers();
  }

  @Watch('getGripEnablersApiState.loading')
  public watchGetGripEnablersLoading(): void {
    this.isLoading = true;
  }

  @Watch('getGripEnablersApiState.success')
  public watchGetGripEnablersSuccess(): void {
    this.isLoading = false;
    this.enablerList =
      this.gripEnablers && this.gripEnablers.items
        ? this.gripEnablers.items
        : [];
  }
}
</script>
<style lang="scss" module></style>
